export { default } from './fetchApi';
